import { C, t } from '../../Dashboard/components/dashboardConstants';
import styles from './ArchiveHeader.module.css';

function IcoTable() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="8" height="8" rx="1" stroke={C.bk} strokeWidth="2"/>
      <rect x="13" y="3" width="8" height="8" rx="1" stroke={C.bk} strokeWidth="2"/>
      <rect x="3" y="13" width="8" height="8" rx="1" stroke={C.bk} strokeWidth="2"/>
      <rect x="13" y="13" width="8" height="8" rx="1" stroke={C.bk} strokeWidth="2"/>
    </svg>
  );
}

function IcoList() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" stroke={C.bk} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

function IcoPlus() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 5v14M5 12h14" stroke="#090909" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

export default function ArchiveHeader({ view, totalCount, onBoardView, onListView, onNewBoard }) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
      padding: '50px 40px 0',
    }}>
      {/* 제목 + 부제목 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h1 style={{ ...t('36px', 600, C.bk), margin: 0 }}>보관함</h1>
        <span style={t('16px', 400, C.sub)}>관심 있는 공고들을 보드로 나누어 체계적으로 관리해보세요.</span>
      </div>

      {/* 버튼 그룹 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {/* 보드 보기 */}
        <button onClick={onBoardView} style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '15px 18px', height: '50px', background: C.white,
          border: `1px solid ${C.g200}`, borderRadius: '10px', cursor: 'pointer',
          boxShadow: view === 'board'
            ? 'inset 2px 2px 12px rgba(0,0,0,0.08)'
            : C.shadow,
        }}>
          <IcoTable />
          <span style={t('18px', 600, '#111111')}>보드 보기</span>
        </button>

        {/* 전체 목록 */}
        <button onClick={onListView} style={{
          display: 'flex', alignItems: 'center', gap: '10px',
          padding: '15px 18px', height: '50px', background: C.white,
          border: `1px solid ${C.g200}`, borderRadius: '10px', cursor: 'pointer',
          boxShadow: view === 'list'
            ? 'inset 2px 2px 12px rgba(0,0,0,0.08)'
            : C.shadow,
        }}>
          <IcoList />
          <span style={t('18px', 600, '#111111')}>전체 목록</span>
        </button>

        {/* 새 보드 */}
        <button onClick={onNewBoard} className={styles.newBoardButton}>
          <IcoPlus />
          <span className={styles.newBoardLabel}>새 보드</span>
        </button>
      </div>
    </div>
  );
}
